let CONFIG = {
  ANIMATION_SPEED: 500,
};

// This file is read by webpack so we need to use the module.exports syntax
module.exports = CONFIG;



// WEBPACK FOOTER //
// ./timeline/js/util/config.js